import React from 'react';
import {
  Container, Typography, Box, Card, CardContent, Tabs, Tab, Grid, TextField,
  Button, FormControl, InputLabel, Select, MenuItem, FormHelperText,
  Switch, FormControlLabel, Avatar, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Alert, CircularProgress, Snackbar,
  Dialog, DialogTitle, DialogContent, DialogActions, Paper, Chip, IconButton,
  Link, CardActions, Divider, Collapse, Autocomplete
} from '@mui/material';
import {
  Business as BusinessIcon, Add as AddIcon, Edit as EditIcon,
  Delete as DeleteIcon, Save as SaveIcon, LocalOffer as LocalOfferIcon,
  ShoppingCart as ShoppingCartIcon, Settings as SettingsIcon,
  FileDownload as ExportIcon, Link as LinkIcon, Phone as PhoneIcon,
  Tablet as TabletIcon, Computer as ComputerIcon, Article as ArticleIcon,
  Schedule as ScheduleIcon, Close as CloseIcon, Category as CategoryIcon,
  ViewModule as TemplateIcon, TrendingUp as UsageIcon,
  Visibility as PreviewIcon, Create as CreateIcon,
  KeyboardArrowDown as KeyboardArrowDownIcon,
  KeyboardArrowRight as KeyboardArrowRightIcon
} from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import dayjs from 'dayjs';
import { Link as RouterLink } from 'react-router-dom';
import OfferPageBuilderSimple from '../../../components/OfferPageBuilderSimple';
import { useBrandsContext } from '../../BrandsContext';

const BrandSetupTab = () => {
  const {
    user, navigate,
    activeTab, setActiveTab,
    brandForm, setBrandForm,
    existingBrands, setExistingBrands,
    loading, setLoading,
    error, setError,
    success, setSuccess,
    editingBrand, setEditingBrand,
    editDialogOpen, setEditDialogOpen,
    deleteDialogOpen, setDeleteDialogOpen,
    brandToDelete, setBrandToDelete,
    offerLoading, setOfferLoading,
    offerError, setOfferError,
    categories, setCategories,
    selectedCategory, setSelectedCategory,
    offerForm, setOfferForm,
    editingOffer, setEditingOffer,
    editOfferDialogOpen, setEditOfferDialogOpen,
    deleteOfferDialogOpen, setDeleteOfferDialogOpen,
    offerToDelete, setOfferToDelete,
    availableOffers, setAvailableOffers,
    availableOffersLoading, setAvailableOffersLoading,
    expandedBrands, setExpandedBrands,
    brandOffers, setBrandOffers,
    sharedElements, setSharedElements,
    sharedSelectedElement, setSharedSelectedElement,
    sharedSelectedElementContext, setSharedSelectedElementContext,
    sharedSelectedCategory, setSharedSelectedCategory,
    sharedSelectedSubtype, setSharedSelectedSubtype,
    sharedSelectedBrand, setSharedSelectedBrand,
    sharedSelectedOffer, setSharedSelectedOffer,
    sharedPages, setSharedPages,
    sharedSelectedTemplateId, setSharedSelectedTemplateId,
    fetchBrands, fetchCategories, fetchAvailableOffers,
    handleToggleBrandOffers, handleTabChange, handleOfferFormChange,
    handleCreateOffer, handleEditOffer, handleDeleteOfferClick,
    handleDeleteOfferConfirm, handleDeleteOfferCancel,
    handleEditOfferCancel, handleEditBrand, handleUpdateBrand,
    handleDeleteClick, handleDeleteConfirm, handleDeleteCancel,
    handleCreateBrand,
    isValidUrl,
  } = useBrandsContext();

  return (
    <Box>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Configure brand information and settings
      </Typography>
    
      <Card>
        <CardContent>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <TextField
                label="Network / Brand"
                fullWidth
                value={brandForm.networkBrand}
                onChange={(e) => setBrandForm({ ...brandForm, networkBrand: e.target.value })}
                placeholder="e.g., Bill pay CO"
                helperText="Enter the network or brand name"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                label="Brand Name"
                fullWidth
                value={brandForm.brandName}
                onChange={(e) => setBrandForm({ ...brandForm, brandName: e.target.value })}
                required
              />
            </Grid>
    
            <Grid item xs={12} md={6}>
              <TextField
                label="Company"
                fullWidth
                value={brandForm.company}
                onChange={(e) => setBrandForm({ ...brandForm, company: e.target.value })}
                placeholder="Enter company name"
                helperText="Optional - company or organization name"
              />
            </Grid>
    
            <Grid item xs={12} md={6}>
              <TextField
                label="Contact Name"
                fullWidth
                value={brandForm.contactName}
                onChange={(e) => setBrandForm({ ...brandForm, contactName: e.target.value })}
                required
              />
            </Grid>
    
            <Grid item xs={12} md={6}>
              <TextField
                label="Contact Email"
                type="email"
                fullWidth
                value={brandForm.contactEmail}
                onChange={(e) => setBrandForm({ ...brandForm, contactEmail: e.target.value })}
                placeholder="contact@company.com"
                helperText="Optional - for brand contact information"
              />
            </Grid>
    
            <Grid item xs={12} md={6}>
              <TextField
                label="Address fields 1"
                fullWidth
                value={brandForm.addressField1}
                onChange={(e) => setBrandForm({ ...brandForm, addressField1: e.target.value })}
              />
            </Grid>
    
            <Grid item xs={12} md={6}>
              <TextField
                label="Address fields 2"
                fullWidth
                value={brandForm.addressField2}
                onChange={(e) => setBrandForm({ ...brandForm, addressField2: e.target.value })}
              />
            </Grid>
    
            <Grid item xs={12} md={4}>
              <FormControl fullWidth>
                <InputLabel>country (auto populate state, city or...)</InputLabel>
                <Select
                  value={brandForm.country}
                  label="country (auto populate state, city or...)"
                  onChange={(e) => setBrandForm({ ...brandForm, country: e.target.value })}
                >
                  <MenuItem value="US">United States</MenuItem>
                  <MenuItem value="CA">Canada</MenuItem>
                  <MenuItem value="UK">United Kingdom</MenuItem>
                  <MenuItem value="AU">Australia</MenuItem>
                  <MenuItem value="DE">Germany</MenuItem>
                  <MenuItem value="FR">France</MenuItem>
                  <MenuItem value="JP">Japan</MenuItem>
                  <MenuItem value="OTHER">Other</MenuItem>
                </Select>
              </FormControl>
            </Grid>
    
            <Grid item xs={12} md={4}>
              <TextField
                label="State/province"
                fullWidth
                value={brandForm.stateProvince}
                onChange={(e) => setBrandForm({ ...brandForm, stateProvince: e.target.value })}
              />
            </Grid>
    
            <Grid item xs={12} md={4}>
              <TextField
                label="city"
                fullWidth
                value={brandForm.city}
                onChange={(e) => setBrandForm({ ...brandForm, city: e.target.value })}
              />
            </Grid>
    
            <Grid item xs={12}>
              <TextField
                label="Website homepage"
                fullWidth
                type="url"
                value={brandForm.websiteHomepage}
                onChange={(e) => setBrandForm({ ...brandForm, websiteHomepage: e.target.value })}
                placeholder="https://example.com"
                error={
                  brandForm.websiteHomepage &&
                  brandForm.websiteHomepage.trim() &&
                  !isValidUrl(brandForm.websiteHomepage.trim())
                }
                helperText={
                  brandForm.websiteHomepage &&
                    brandForm.websiteHomepage.trim() &&
                    !isValidUrl(brandForm.websiteHomepage.trim())
                    ? 'Please enter a valid URL (e.g., https://example.com)'
                    : 'Must include http:// or https:// (e.g., https://onnit.com)'
                }
              />
            </Grid>
    
            <Grid item xs={12} md={4}>
              <TextField
                label="Tiktok"
                fullWidth
                value={brandForm.tiktok}
                onChange={(e) => setBrandForm({ ...brandForm, tiktok: e.target.value })}
                placeholder="@username or profile URL"
              />
            </Grid>
    
            <Grid item xs={12} md={4}>
              <TextField
                label="Instagram"
                fullWidth
                value={brandForm.instagram}
                onChange={(e) => setBrandForm({ ...brandForm, instagram: e.target.value })}
                placeholder="@username or profile URL"
              />
            </Grid>
    
            <Grid item xs={12} md={4}>
              <TextField
                label="Facebook"
                fullWidth
                value={brandForm.facebook}
                onChange={(e) => setBrandForm({ ...brandForm, facebook: e.target.value })}
                placeholder="Page name or URL"
              />
            </Grid>
    
    
    
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Switch
                    checked={brandForm.status}
                    onChange={(e) => setBrandForm({ ...brandForm, status: e.target.checked })}
                  />
                }
                label="Active Brand"
              />
            </Grid>
    
            <Grid item xs={12}>
              <Box sx={{ display: 'flex', gap: 2 }}>
                <Button
                  variant="contained"
                  startIcon={<SaveIcon />}
                  onClick={handleCreateBrand}
                  disabled={!brandForm.brandName || !brandForm.contactName}
                >
                  Create Brand
                </Button>
                <Button
                  variant="outlined"
                  onClick={() => setBrandForm({
                    networkBrand: '',
                    brandName: '',
                    company: '',
                    contactName: '',
                    contactEmail: '',
                    addressField1: '',
                    addressField2: '',
                    country: '',
                    stateProvince: '',
                    city: '',
                    websiteHomepage: '',
                    tiktok: '',
                    instagram: '',
                    facebook: '',
                    status: true
                  })}
                >
                  Clear Form
                </Button>
              </Box>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Box>
  );
};

export default BrandSetupTab;
